import { clsx } from 'clsx'

type Props = {
  'value': boolean
  'onChange': (value: boolean) => void
  'disabled'?: boolean
  'aria-label'?: string
}

export function ToggleSwitch({
  value,
  onChange,
  disabled = false,
  'aria-label': ariaLabel
}: Props) {
  return (
    <button
      type="button"
      className="group relative inline-flex h-[18px] w-8 shrink-0 cursor-pointer items-center justify-center rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:cursor-not-allowed disabled:opacity-50"
      role="switch"
      aria-checked={value}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!value)}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute size-full rounded-md bg-white"
      />
      <span
        aria-hidden="true"
        className={clsx(
          'pointer-events-none absolute mx-auto h-3.5 w-[30px] rounded-full transition-colors duration-200 ease-in-out',
          { 'bg-blue-600': value, 'bg-gray-200': !value }
        )}
      />
      <span
        aria-hidden="true"
        className={clsx(
          'pointer-events-none absolute left-0 inline-block size-[18px] transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out',
          { 'translate-x-3.5': value, 'translate-x-0': !value }
        )}
      />
    </button>
  )
}
